module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/cv_3_sp_fb5ef430f9aa785db3f3a2166dd0a39b.jpg";